(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palmr-hat-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.phg').forEach(function (root) {
    var grid = root.querySelector('[data-phg-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.phg-card'));
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 24;
    var shown = pageSize;
    var fam = 'all', fit = false;
    var trust = root.querySelector('[data-phg-trust]');
    var styleRow = root.querySelector('[data-phg-style]');
    var fitBtn = root.querySelector('[data-phg-fit]');
    /* style, fit and how many hats are shown live in the address, so Back, refresh and a shared link keep them */
    var q = new URLSearchParams(location.search);
    /* only styles that have a chip on this page count; older names map across; anything else falls back to All */
    var aliases = { signature: 'sig', heritage: 'her', classic: 'cla', florida: 'fl', orl: 'orl', t1d: 't1d', more: 'more' };
    var qs = (q.get('hat_style') || '').toLowerCase();
    qs = aliases[qs] || qs;
    if (qs && styleRow && styleRow.querySelector('[data-f="' + qs.replace(/[^a-z0-9]/g, '') + '"]')) fam = qs;
    /* a fit filter only applies when the Small Fit toggle is on the page */
    if (fitBtn && q.get('hat_fit') === 'small') fit = true;
    var qn = parseInt(q.get('hat_count'), 10);
    if (qn > pageSize) shown = Math.ceil(qn / pageSize) * pageSize;
    function saveState() {
      var u = new URL(location.href);
      if (fam !== 'all') u.searchParams.set('hat_style', fam); else u.searchParams.delete('hat_style');
      if (fit) u.searchParams.set('hat_fit', 'small'); else u.searchParams.delete('hat_fit');
      if (shown > pageSize && fam === 'all' && !fit) u.searchParams.set('hat_count', shown); else u.searchParams.delete('hat_count');
      if (u.href !== location.href) history.replaceState(history.state, '', u.href);
    }
    var load = root.querySelector('[data-phg-load]');
    var count = root.querySelector('[data-phg-count]');
    var barTop = function () {
      var bar = root.querySelector('.phg-bar');
      var cs = getComputedStyle(document.documentElement);
      return bar.getBoundingClientRect().top + window.scrollY - (parseInt(cs.getPropertyValue('--theme-sticky-header-height')) || 0) - (parseInt(cs.getPropertyValue('--palmr-announce-h')) || 0);
    };
    function apply(scroll) {
      var filtered = fam !== 'all' || fit;
      var visible = 0, matching = 0;
      cards.forEach(function (c) {
        var ok = (fam === 'all' || c.getAttribute('data-fam') === fam || (fam === 't1d' && c.hasAttribute('data-t1d'))) && (!fit || c.hasAttribute('data-fit'));
        c.classList.toggle('phg-card--hide', !ok);
        if (ok) { matching++; var paged = !filtered && matching > shown; c.classList.toggle('phg-card--page', paged); if (!paged) visible++; }
        else c.classList.remove('phg-card--page');
      });
      var left = matching - visible;
      if (load) { load.hidden = left <= 0; load.textContent = load.getAttribute('data-label') + ' (' + left + ')'; }
      if (count) count.textContent = 'Showing ' + visible + ' of ' + matching;
      if (trust) {
        var shownCards = cards.filter(function (c) { return !c.classList.contains('phg-card--hide') && !c.classList.contains('phg-card--page'); });
        var after = shownCards[Math.min(3, shownCards.length - 1)];
        if (after && after.nextElementSibling !== trust) after.after(trust);
        trust.hidden = shownCards.length === 0;
      }
      saveState();
      if (scroll && window.scrollY > barTop()) window.scrollTo({ top: barTop(), behavior: 'smooth' });
    }
    if (load) { load.setAttribute('data-label', load.textContent); load.addEventListener('click', function () { shown += pageSize; apply(false); }); }
    if (styleRow) styleRow.addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]'); if (!b) return;
      fam = b.getAttribute('data-f');
      styleRow.querySelectorAll('[data-f]').forEach(function (x) { x.classList.toggle('phg-chip--on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      apply(true);
    });
    if (fitBtn) fitBtn.addEventListener('click', function () {
      fit = !fit;
      fitBtn.setAttribute('aria-pressed', fit ? 'true' : 'false');
      apply(true);
    });
    if (styleRow && fam !== 'all') styleRow.querySelectorAll('[data-f]').forEach(function (x) { var on = x.getAttribute('data-f') === fam; x.classList.toggle('phg-chip--on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    if (fitBtn && fit) fitBtn.setAttribute('aria-pressed', 'true');
    apply(false);
  });

  /* area-code picker, adapted from Astra's codex-hat-finder: search, a modal
     sheet where dialog is supported, campaign parameters kept on the links */
  if (!customElements.get('palmr-code-picker')) {
    customElements.define('palmr-code-picker', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this.ready) return;
        this.ready = true;
        const details = this.querySelector('details');
        const trigger = details.querySelector('summary');
        const panel = this.querySelector('.phg-pick__panel');
        const title = panel.querySelector('.phg-pick__h');
        const input = panel.querySelector('input');
        const items = Array.from(panel.querySelectorAll('[data-q]'));
        const status = panel.querySelector('[role="status"]');
        const empty = panel.querySelector('.phg-pick__empty');
        const close = panel.querySelector('.phg-pick__x');
        const uid = 'phg-pick-' + Math.random().toString(36).slice(2, 8);
        panel.id = uid + '-panel'; title.id = uid + '-title'; input.id = uid + '-in';
        panel.querySelector('label').htmlFor = input.id;
        const norm = v => v.toLowerCase().replace(/[^a-z0-9]/g, '');
        const filter = () => {
          const q = norm(input.value); let n = 0;
          items.forEach(li => { li.hidden = !norm(li.dataset.q).includes(q); if (!li.hidden) n++; });
          empty.hidden = n !== 0;
          status.textContent = q ? n + ' area code' + (n === 1 ? '' : 's') + ' shown' : '';
        };
        input.addEventListener('input', filter);
        panel.querySelector('.phg-pick__search').hidden = false;
        const incoming = new URLSearchParams(location.search);
        panel.querySelectorAll('a').forEach(a => {
          const url = new URL(a.href, location.origin);
          for (const [k, v] of incoming) if (k === 'preview_theme_id' || k.startsWith('utm_') || ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid'].includes(k)) url.searchParams.set(k, v);
          a.href = url.href;
        });
        if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
        const dialog = document.createElement('dialog');
        dialog.className = 'phg-pick__dialog';
        dialog.setAttribute('aria-labelledby', title.id);
        dialog.append(panel);
        this.append(dialog);
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');
        close.hidden = false;
        let prev;
        const unlock = () => {
          if (prev !== undefined) { document.documentElement.style.overflow = prev; prev = undefined; }
          trigger.setAttribute('aria-expanded', 'false');
        };
        this.dismiss = () => { if (dialog.open) dialog.close(); unlock(); };
        trigger.addEventListener('click', e => {
          e.preventDefault();
          input.value = ''; filter();
          prev = document.documentElement.style.overflow;
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
          trigger.setAttribute('aria-expanded', 'true');
          title.focus({ preventScroll: true });
        });
        close.addEventListener('click', this.dismiss);
        dialog.addEventListener('close', () => { unlock(); if (this.isConnected) trigger.focus({ preventScroll: true }); });
        let down = false;
        dialog.addEventListener('pointerdown', e => { down = e.target === dialog; });
        dialog.addEventListener('click', e => { if (down && e.target === dialog) this.dismiss(); down = false; });
        dialog.querySelectorAll('a').forEach(a => a.addEventListener('click', this.dismiss));
      }
      disconnectedCallback() { if (this.dismiss) this.dismiss(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palmr-related-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  function loadPalmrRelated(el) {
    if (!el || !el.dataset.url) return;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', el.dataset.url);
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        var tmp = document.createElement('div');
        tmp.innerHTML = xhr.response;
        var fresh = tmp.querySelector('[data-section-id="' + el.dataset.sectionId + '"].palmr-related');
        if (fresh) {
          el.innerHTML = fresh.innerHTML;
        }
      }
    };
    xhr.send();
  }

  function init() {
    document.querySelectorAll('.palmr-related').forEach(loadPalmrRelated);
  }

  document.addEventListener('shopify:section:load', function(event) {
    var el = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].palmr-related');
    if (el) loadPalmrRelated(el);
  });

  init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
